export default __webpack_public_path__ + "static/media/offing-natasha-rao.a29d1579.webp";